import * as React from 'react';

import styles from './styles.module.scss';

export const Field = ({ ...other }) => (
  <div className={styles.field} {...other} />
);

export default Field;
